/* eslint-disable react/jsx-props-no-spreading */
import BootstrapButton from "react-bootstrap/Button";
import styled from "styled-components";

const Button = styled(BootstrapButton)`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

export default Button;
